export default function (iteration, duration) {

	var start = performance.now();

	var animate = function animate(time) {

		var timePassed = time - start,
		    perc = duration / 100,
		    progress = Math.floor(timePassed / perc);

		if (timePassed < 0) timePassed = 0;
		if (timePassed > duration) timePassed = duration;

		if (progress < 0) progress = 0;
		if (progress > 100) progress = 100;

		iteration(progress);

		if (timePassed < duration) {
			requestAnimationFrame(animate);
		}
	};

	requestAnimationFrame(animate);
}


//////////////////
// WEBPACK FOOTER
// ./plugins/animation-timeout.js
// module id = ./plugins/animation-timeout.js
// module chunks = 0